exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2f2wz{text-align:center;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:rgba(0,0,0,.42);overflow:none}.kUvEQ{height:100px;width:100px;margin:0 auto;position:absolute;top:50%;left:50%;margin-top:-50px;margin-left:-50px}", ""]);

// exports
exports.locals = {
	"root": "_2f2wz",
	"container": "kUvEQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Loading/Loading.css
// module id = 1110
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13